import type { PluginDefinition } from "@magic-md/core";
import { useEditorStore } from "../store/editor-store";
import {
    findParentForBlockId,
    getMergedDefinitions,
} from "./scope-variables";

type AsyncLike = Promise<unknown> | unknown;

export async function runDefinitionWithFallback({
    definition,
    isDirty,
    applyDraft,
    runPrimary,
    runForAction,
}: {
    definition: PluginDefinition;
    isDirty: boolean;
    applyDraft: () => void;
    runPrimary: (
        definition: PluginDefinition,
        definitions: Map<string, PluginDefinition>,
    ) => AsyncLike;
    runForAction: (definitionId: string) => AsyncLike;
}) {
    if (isDirty) applyDraft();

    const freshDocument = useEditorStore.getState().parsedDocument;
    const mergedDefinitions = getMergedDefinitions(freshDocument);
    const nextDefinition = mergedDefinitions.get(definition.id) ?? definition;

    const parentForId = findParentForBlockId(definition.id, freshDocument?.forDefinitions);
    if (parentForId) {
        await runForAction(parentForId);
        return;
    }

    await runPrimary(nextDefinition, mergedDefinitions);
}
